import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { cn } from '../../../../utils/cn';

export type MoneyMovementRange = 'current_month' | 'last_month' | 'last_3_months' | 'last_6_months' | 'last_year';

type MoneyMovementFilterProps = {
  value: MoneyMovementRange;
  onChange: (value: MoneyMovementRange) => void;
  className?: string;
};

const OPTIONS: { value: MoneyMovementRange; label: string }[] = [
  { value: 'current_month', label: 'Current Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_6_months', label: 'Last 6 Months' },
  { value: 'last_year', label: 'Last Year' },
];

export const MoneyMovementFilter = ({ value, onChange, className }: MoneyMovementFilterProps) => {
  return (
    <Inline role="radiogroup" aria-label="Money movement range" space={3} className={className}>
      {OPTIONS.map((opt) => {
        const selected = value === opt.value;
        return (
          <Button
            key={opt.value}
            role="radio"
            aria-checked={selected}
            type="button"
            onClick={() => onChange(opt.value)}
            variant={'outline'}
            className={cn(
              selected ? 'bg-white text-black' : 'border-transparent bg-seapoint-gray-medium text-seapoint-gray-text',
            )}
          >
            {opt.label}
          </Button>
        );
      })}
    </Inline>
  );
};
